import {PayloadSDK} from '@payloadcms/sdk'

import type {Config} from '~/types/cms'

let sdkInstance: PayloadSDK<Config> | null = null

/**
 * Composable to get the Payload REST API SDK instance.
 * Creates a singleton instance that reuses the same SDK across the app.
 */
export function usePayloadSdk() {
  if (sdkInstance) {
    return sdkInstance
  }

  const {payloadUrl} = useRuntimeConfig()

  const headers = typeof useRequestHeaders === 'function' ? useRequestHeaders() : undefined
  sdkInstance = new PayloadSDK<Config>({
    baseURL: import.meta.dev ? 'http://localhost:3000/api' : payloadUrl || '/api',
    baseInit: {
      headers,
    },
  })

  return sdkInstance
}
